// extracted by mini-css-extract-plugin
export default {"reana-page":"BasePage_reana-page__dlr10","main":"BasePage_main__nhsRL"};